const funcState = (initialValue) => {
  const value = { value: initialValue };
  const update = (updatedValue) => {
    value.value = updatedValue;
  };
  return [value, update];
};

export { funcState };
